import Box from "../../lib/appfuse-react/component/Box";
import {Link, Route, Switch, useRouteMatch} from "react-router-dom";
import Dock, {DockItem} from "../../lib/appfuse-react/component/Dock";
import Paper from "../../lib/appfuse-react/component/Paper";
import React from "react";
import PromptTest from "./PromptTest";
import ButtonTest from "./ButtonTest";

function KitchenSink(props) {
    const { path } = useRouteMatch();
    return (
        <Box display="flex" fullWidth fullHeight>
            <Dock translucent>
                <Link to={path}>
                    <DockItem icon="home" text="Home" />
                </Link>
                <Link to={`${path}/PromptTest`}>
                    <DockItem icon="message" text="Prompt Test" />
                </Link>
                <Link to={`${path}/ButtonTest`}>
                    <DockItem icon="smart_button" text="Button Test" />
                </Link>
                <DockItem icon="help" text="Help" />
            </Dock>
            <Paper square variant={"outlined"} fullHeight fullWidth>
                <Switch>
                    <Route path={`${path}/PromptTest`}>
                        <PromptTest />
                    </Route>
                    <Route path={`${path}/ButtonTest`}>
                        <ButtonTest />
                    </Route>
                </Switch>
            </Paper>
        </Box>
    );
}
export default KitchenSink;